export const flowTypes = {
    FLOW_MODE_REQUEST: "FLOW_MODE_REQUEST",
    FLOW_MODE_SUCCESS: "FLOW_MODE_SUCCESS",
    FLOW_MODE_FAILURE: "FLOW_MODE_FAILURE",
    FETCH_INSIGHTS_REQUEST: "FETCH_INSIGHTS_REQUEST",
    FETCH_INSIGHTS_SUCCESS: "FETCH_INSIGHTS_SUCCESS",
    FETCH_INSIGHTS_FAILURE: "FETCH_INSIGHTS_FAILURE",
    SEND_FLOW_FEEDBACK_REQUEST: "SEND_FLOW_FEEDBACK_REQUEST",
    SEND_FLOW_FEEDBACK_SUCCESS: "SEND_FLOW_FEEDBACK_SUCCESS",
    SEND_FLOW_FEEDBACK_FAILURE: "SEND_FLOW_FEEDBACK_FAILURE",
    SHOW_PREVIOUS_CHAT_LAYOUT: "SHOW_PREVIOUS_CHAT_LAYOUT",
};
